require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-introducing-the-new-talent-portal.json") })
        }
      }, "path---blog-introducing-the-new-talent-portal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-introducing-the-new-talent-portal!./.cache/json/blog-introducing-the-new-talent-portal.json
// module id = 899
// module chunks = 231608221292675